const list = [
  // {fileName: "/images/...", title: "..."},
]

export default { list };